import React from 'react';
import Cookies from 'universal-cookie';

import {Visibility,VisibilityOff} from '@material-ui/icons';
import { createTheme } from "@material-ui/core/styles";

import {
    Typography,
    Box,
    Paper,
    TextField,
    Button,
    FormControl,
    FormHelperText,
    InputAdornment,
    IconButton
} from '@material-ui/core';

//css
import FormPerfilCss from './FormPerfil-css';
const useStyles = FormPerfilCss();

const theme = createTheme({
    overrides: {
        MuiInputLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                color: "rgb(118, 118, 118)",
                "&$focused": { // increase the specificity for the pseudo class
                    color: "#159B78"
                }
            }
        }
    }
});

export default function Section(props) {
    const classes = useStyles();

    const [values, setValues] = React.useState({
        showPassword: false,
    });
    
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const handleMouseDownPassword = event => {
        event.preventDefault();
    };

    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>

                    <Box component="span" m={1}>
                        <Paper className={classes.root}>
                            <div className={classes.boxForm}>
                                <Typography variant="h5" component="h3" className={classes.title}>
                                    {(props.props.renov)?"Alterar senha":"Perfil"}
                                </Typography>
                                <form className={classes.container} noValidate autoComplete="off">
                                    <FormControl className={classes.formControl} error>
                                        <TextField
                                            id="tf_codigo"
                                            label="Código"
                                            className={classes.textField}
                                            InputProps={{
                                                className: classes.multilineColor
                                            }}
                                            disabled={true}
                                            margin="normal"
                                            onChange={(e)=>{props.setState({codigo:e.target.value})}}
                                            value={props.state.codigo}
                                        />
                                        <FormHelperText className={classes.textField} hidden={true} id="component-error-text">Nome deve conter mais de 3 caracteres!</FormHelperText>
                                    </FormControl>
                                    <br/>
                                    <FormControl className={classes.formControl} error>
                                        <TextField
                                            id="tf_nome"
                                            label="Nome"
                                            className={classes.textField}
                                            error={!props.state.validoNome}
                                            InputProps={{
                                                className: classes.multilineColor
                                                }}
                                                margin="normal"
                                                onChange={(e)=>{props.setState({nome:e.target.value})}}
                                                value={props.state.nome}
                                            disabled={true}
                                            />
                                        <FormHelperText className={classes.textField} hidden={props.state.validoNome} id="component-error-text">Nome deve conter mais de 3 caracteres!</FormHelperText>
                                    </FormControl>
                                    <br/>
                                    <FormControl className={classes.formControl} error>
                                        <TextField variant={"filled"}
                                            id="tf_senha"
                                            label="Senha"
                                            className={classes.textField}
                                            error={!props.state.validoSenha}
                                            type={values.showPassword ? 'text' : 'password'}
                                            margin="normal"
                                            onChange={(e)=>{props.setState({senha:e.target.value})}}
                                            value={props.state.senha}
                                            InputProps={{
                                                className: classes.multilineColor,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            edge="end"
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                        >
                                                            {values.showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        <FormHelperText className={classes.textField} hidden={props.state.validoSenha} id="component-error-text">Senha deve conter no mínimo 6 caracteres e no máximo 12!</FormHelperText>
                                    </FormControl>
                                    <br/>
                                    <div className={classes.buttonAction} align="right">
                                        <Button 
                                            className={classes.buttonCancelar}
                                            onClick={()=>{
                                                if (props.props.renov) {
                                                    const cookies = new Cookies();
                                                    cookies.set('User-Token','');
                                                    window.location.reload();
                                                } else {
                                                    props.props.router.push('/');
                                                }
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                            onClick={()=>{props.editData()}}
                                            style={{
                                                background: '#0a775a'
                                            }}
                                        >
                                            Salvar
                                        </Button>
                                    </div>
                                    <br/>
                                </form>
                            </div>
                        </Paper>
                    </Box>

            </div>
        </div>
    );
}